import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  theme: {
    dark: localStorage.getItem("darkMode") === "true",
    themes: {
      light: {
        primary: "#014991",
        secondary: "#3F51B5",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#ff8f00",
        disable: "#bebebe",
        lightgray: "#eee",
        white: "#fff",
      },
      dark: {
        primary: "#4d9de0",
        secondary: "#7986CB",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#ff8f00",
        disable: "#bebebe",
        lightgray: "#eee",
        white: "#fff",
      },
    },
  },
});

//cor primaria #1543B7
//cor secundaria #2562FF
